document.addEventListener('DOMContentLoaded', function () {
  window.countryNav = {
    cookieKey: 'countryNavV2',
    cookieKeyInfo: 'countryNavInfo',
    init: function () {
      var countryNavActive = this.isActive();
      if (countryNavActive) {
        document.getElementById('site-selector-modal-country').style.display = 'none';
        window.dispatchEvent(new CustomEvent('country-modal:close'));
      }
    },

    country: () => cookies.getCookie(countryNav.cookieKey),

    isActive: () => countryNav.country() == Shopify.country,

    toggle: function () {
      if (!cookies.getCookie(countryNav.cookieKey)) {
        this.suppressWrongSitePopup(Shopify.country);
      }
      document.getElementById('site-selector-modal-country').style.display = 'none';
    },

    suppressWrongSitePopup: function (country) {
      cookies.setCookie(countryNav.cookieKey, country, 365, 'representclo.com');
    }
  };

  countryNav.init();

  const flag_names = document.querySelectorAll('[js-flag-name]');
  const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
  flag_names.forEach((flag_name) => {
    flag_name.innerText = regionNames.of(Shopify.country);
  });

  if (Shopify.designMode) {
    return;
  }

  const currencyConfiguration = Object.values(CURRENCY_CONFIGURATION)
    .filter(configuration => window.location.href.includes(configuration.site));

  if (!currencyConfiguration) {
    throw new Error(`No currency configuration found for site: ${window.location.href}`);
  }

  const supportedCountries = currencyConfiguration.flatMap(configuration => configuration.countries);

  // Check if country is already active (saved country matches Shopify country)
  if (countryNav.isActive() && supportedCountries.includes(countryNav.country())) {
    return;
  }

  // Only proceed with geo-detection if country is not active
  const getGeo = async () => {
    const response = await fetch('/browsing_context_suggestions.json');
    if (!response.ok) {
      throw new Error(`GeoIP HTTP error status: ${response.status}`);
    }

    const responseData = await response.json();
    const countryCodeFromGeoIP = responseData?.detected_values?.country?.handle;

    if (countryCodeFromGeoIP == 'DE') {
      let form_id_ge = '14a177aa1488b8f81b7d7a81b9bcbbc5';
      document.querySelectorAll('input[name=__form_id]').forEach((x) => {
        x.value = form_id_ge;
      });
    }

    let shopifyCountry = Shopify.country;

    const setSelectedCountry = (countryCode) => {
      if (document.getElementById(countryCode)) {
        document.querySelector(`#site-selector-modal-country #${countryCode}`).selected = true;
      } else {
        document.querySelector(`#site-selector-modal-country #${shopifyCountry}`).selected = true;
      }
    };

    const openWrongSitePopup = () => {
      document.getElementById('site-selector-modal-country').style.display = 'flex';
      window.dispatchEvent(new CustomEvent('country-modal:open'));
    };

    const initWrongSitePopup = () => {
      const skipCheckingPopup = window.location.search.includes('drawer=CountryLanguageDrawer');
      if (skipCheckingPopup) {
        return;
      }

      const savedCountry = countryNav.country();

      // Case 1: If returning user with saved country preference
      if (savedCountry) {
        setSelectedCountry(savedCountry);
        updateCountryModal(savedCountry);

        // Show popup if their saved country isn't in supported countries
        if (!supportedCountries.includes(savedCountry)) {
          openWrongSitePopup();
          return;
        }
      }

      // Case 2: For new users or users without saved preference, check IP country
      if (!supportedCountries.includes(countryCodeFromGeoIP)) {
        setSelectedCountry(countryCodeFromGeoIP);
        updateCountryModal(countryCodeFromGeoIP);
        openWrongSitePopup();
        return;
      } else if (!savedCountry) {
        // IP country matches supported countries, store it as preference
        // but only if they don't already have a saved preference
        countryNav.suppressWrongSitePopup(countryCodeFromGeoIP);
      }

      // Default: Set to Shopify country and check if it's supported
      setSelectedCountry(shopifyCountry);
      updateCountryModal(shopifyCountry);

      if (!supportedCountries.includes(shopifyCountry)) {
        console.warn(
          `Current market (${shopifyCountry}) is not configured for the following currency configuration`,
          currencyConfiguration,
        );
        openWrongSitePopup();
        return;
      }

      // Popup is closed by default but doesn't trigger this event.
      window.dispatchEvent(new CustomEvent('country-modal:close'));
    };

    try {
      initWrongSitePopup();
    } catch (err) {
      console.error(err);
      setSelectedCountry(shopifyCountry);
      updateCountryModal(shopifyCountry);
      countryNav.suppressWrongSitePopup(shopifyCountry);
      window.dispatchEvent(new CustomEvent('country-modal:failed'));
    }

    return countryCodeFromGeoIP;
  };

  getGeo()
    .then(console.log)
    .catch((err) => {
      console.error('Geolocation fetch failed:', err);
      window.dispatchEvent(new CustomEvent('country-modal:failed'));
    });
});
